import store from '../store'
import {
  ConfirmParams,
  mapStateToProps as state,
  mapDispatchToProps as actions
} from '../components/Confirm/Confirm.state'

export default {
  get state () {
    return state(store.getState())
  },

  push (confirm: ConfirmParams) {
    store.dispatch(actions.push(confirm))
  },

  cancel () {
    store.dispatch(actions.cancel())
  }
}
